import { useQuery } from '@tanstack/react-query';
import { QUERY_KEYS } from '../../data/constants';
import { getActionById } from '../../api/production-request-api/index.js';
import { useApiReady } from '@pella/fetch-client-react';

/**
 * Hook to fetch a specific action by its ID.
 * @param {string} actionId - The ID of the action to retrieve.
 */
export const useAction = (actionId) => {
  const { apiReady } = useApiReady();

  return useQuery({
    queryKey: [QUERY_KEYS.ACTION_DATA, actionId],
    queryFn: () => getActionById(actionId),
    enabled: Boolean(apiReady && actionId),
  });
};
